import { type CustomField } from '@webapp/core/entities/internal/CustomField'
import {
  type SourceMappingBuildContext,
  type SourceMappingOptionGroup,
  type MappingOption,
} from '../types'

export const mapCustomFieldToOption = (
  customField: CustomField
): MappingOption => ({
  label: customField.name,
  value: customField.id.toString(),
  type: 'custom',
  active: customField.active,
})

export const buildActiveCustomFieldOptions = (
  context: SourceMappingBuildContext
): SourceMappingOptionGroup | null => {
  const { customFields, translatedLabels } = context

  const activeFields = customFields.filter((cf) => cf.active)

  if (activeFields.length === 0) {
    return null
  }

  return {
    label: translatedLabels.activeFieldsGroupLabel,
    options: activeFields.map(mapCustomFieldToOption),
  }
}
